import { isDefined, getYear } from "@perxis-auto/shared";
const formatVehicleDescription = (extItem) => {
  const { version, productionDate } = extItem.data;
  if (!isDefined(version == null ? void 0 : version.displayName)) {
    return "";
  }
  const year = productionDate ? getYear(new Date(productionDate)) : null;
  return `${version.displayName}${year ? `, ${year}` : ""}`.trim();
};
export {
  formatVehicleDescription
};
